import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-45aae620"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("img", {
    style: {
      "max-width": "100%",
      "max-height": "800px"
    },
    src: _ctx.srcRef,
    alt: _ctx.alt
  }, null, 8, _hoisted_1);
}